import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tabs, Tab} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';
import {useSubcontractorDetailsStore} from '../SubcontractorDetailsStore';
import {getDocumentsByCountry} from '../../../utils/document';

function TabsView(props) {
  const {
    state: {
      documents,
      archives,
      interventions,
      users,
      reminders,
      dossierCountry
    }
  } = useSubcontractorDetailsStore();

  return (
    <div style={{backgroundColor: '#f5f5f5', margin: '0 -45px 30px', padding: '0 45px'}}>
      <Tabs
        value={props.currentNav}
        onChange={props.onTabSelect}
        TabIndicatorProps={{style: {backgroundColor: '#E72580'}}}
        textColor="primary"
      >
        <Tab
          data-id="tab-subcontractor-details-documents"
          value="/documents"
          label={
            <div className="m-0">
              <Translate value="subcontractor.documents"/>
              <span className="separator information">
                {documents.loading ?
                  <Icon icon="loader"/> :
                  getDocumentsByCountry(documents.list, dossierCountry).length
                }
              </span>
            </div>
          }
        />
        <Tab
          data-id="tab-subcontractor-details-archives"
          value="/archives"
          label={
            <div className="m-0">
              <Translate value="subcontractor.archives"/>
              <span className="separator information">
                {archives.loading ?
                  <Icon icon="loader"/> :
                  archives.list.length
                }
              </span>
            </div>
          }
        />
        <Tab
          data-id="tab-subcontractor-details-users"
          value="/users"
          label={
            <div className="m-0">
              <Translate value="organisation.users.title"/>
              <span className="separator information">
                {users.loading ?
                  <Icon icon="loader"/> :
                  users.totalCount
                }
              </span>
            </div>
          }
        />
        <Tab
          data-id="tab-subcontractor-details-projects"
          value="/projects"
          label={
            <div className="m-0">
              <Translate value="project.myProjects"/>
              <span className="separator information">
                {interventions.loading ?
                  <Icon icon="loader"/> :
                  interventions.totalCount
                }
              </span>
            </div>
          }
        />
        <Tab
          data-id="tab-subcontractor-details-document-reminders"
          value="/document-reminders"
          label={
            <div className="m-0">
              <Translate value="subcontractor.reminders"/>
              <span className="separator information">
                {reminders.loading ?
                  <Icon icon="loader"/> :
                  reminders.totalCount
                }
              </span>
            </div>
          }
        />
      </Tabs>
    </div>
  );
}

TabsView.propTypes = {
  currentNav: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  onTabSelect: PropTypes.func.isRequired
};

export default TabsView;
